module.exports = __webpack_public_path__ + "static/img/icon_exceptional@2x.8979b290.png";